import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const NotificationContainer = styled.div`
  position: fixed;
  bottom: 2px;
  right: 0px;
  display: flex;
  flex-direction: column;
  z-index: 1000002;
  max-height: 50%;
  overflow-x: hidden;
  overflow-y: auto;
`;

NotificationContainer.propTypes = {
  children: PropTypes.array.isRequired,
};

export default NotificationContainer;
